import PubSub from "pubsub-js";
import BBox from '@turf/bbox';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var MapWithMarkersSimple = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-MapWithMarkersSimple',
  };

  $.extend(true, this.options, options);

};

MapWithMarkersSimple.prototype.init = function () {

  var self = this;

  this.mapboxMarkers = [];

  this.initMap();

  /*
	// when a map marker is clicked
	this.options.$el.find(`.${self.options.baseClass}__mapContainer`).on('click', `.${self.options.baseClass}__marker .${self.options.baseClass}__iconWrapper, .${self.options.baseClass}__marker .${self.options.baseClass}__markerDetailWrapper`, function() {

		var markerLat = $(this).closest(`.${self.options.baseClass}__marker`).data('markerLat');
    	var markerLng = $(this).closest(`.${self.options.baseClass}__marker`).data('markerLng');

		var flyToLat = Number(markerLat);
    	var flyToLng = Number(markerLng) + 0.0022; // adding a bit on here because our markers are not centered at the address point

		self.map.flyTo({
	    	center: [
	    		flyToLng,
	    		flyToLat
	    	],
	    	zoom: 15
	    });

	});

	this.options.$el.find(`.${self.options.baseClass}__mapContainer`).on('mouseenter', `.${self.options.baseClass}__marker .${self.options.baseClass}__iconWrapper`, function() {

		$(this).closest(`.${self.options.baseClass}__marker`).addClass(`${self.options.baseClass}__marker--active`);

	});

	this.options.$el.find(`.${self.options.baseClass}__mapContainer`).on('mouseleave', `.${self.options.baseClass}__marker`, function() {
		$(this).removeClass(`${self.options.baseClass}__marker--active`);
	});
	*/

};

MapWithMarkersSimple.prototype.initMap = function () {

  var self = this;

  mapboxgl.accessToken = 'pk.eyJ1IjoiYXV0aGVudGljZmYiLCJhIjoiUmtjWTY2byJ9.QeHZuWdaMRJlobq_RgXngw';

  var componentId = this.options.$el.data('componentId');

  // get our initial map settings
  var mapInitWindowVarName = componentId + 'MapInitSettings';
  this.mapInitSettings = window[mapInitWindowVarName];

  console.log('map init');
  console.log(mapInitWindowVarName);
  console.log(this.mapInitSettings);

  // get our geoJson
  this.geoJson = window[componentId];

  var dragPanSetting = true;
  if (window.screen.width <= 768) {
    dragPanSetting = false;
  }

  console.log('zoom');
  console.log(self.mapInitSettings.startZoom);

  this.map = new mapboxgl.Map({
    container: self.options.$el.find(`.${self.options.baseClass}__mapContainer`)[0],
    style: 'mapbox://styles/authenticff/cl2knq1ta000o14pba4gcwe3m',
    dragPan: dragPanSetting,
    center: [self.mapInitSettings.centerLng, self.mapInitSettings.centerLat],
    zoom: self.mapInitSettings.startZoom,
  });

  // disable scroll to zoom
  this.map.scrollZoom.disable();

  // fix for map size on load
  this.map.resize();

  this.map.addControl(new mapboxgl.NavigationControl());

  this.addPOIs();

  this.centerMapAroundMarkers();

  PubSub.subscribe("resized", function () {
    self.centerMapAroundMarkers();
  });

};

MapWithMarkersSimple.prototype.centerMapAroundMarkers = function () {

  var self = this;

  // get POI bounding box
  var bbox = BBox({
    type: 'FeatureCollection',
    features: self.geoJson.features
  });

  // get map padding based on window size
  if ($(window).width() <= 480) {
    var paddingArray = {
      top: 40,
      bottom: 40,
      left: 40,
      right: 40
    }; // top and right are different because our markers are not centered on the point
  } else if ($(window).width() <= 768) {
    var paddingArray = {
      top: 50,
      bottom: 50,
      left: 50,
      right: 50
    }; // top and right are different because our markers are not centered on the point
  } else {
    var paddingArray = {
      top: 60,
      bottom: 60,
      left: 60,
      right: 60
    }; // top and right are different because our markers are not centered on the point
  }

  // zoom map to bounding box
  if (this.geoJson.features.length > 1) {
    this.map.fitBounds(bbox, {
      padding: paddingArray,
      duration: 1100
    });
  } else if (this.geoJson.features.length == 1) {
    // there's only one marker, so just center the map around the marker
    // and leave the user selected zoom in place
    this.map.flyTo({
      center: this.geoJson.features[0].geometry.coordinates
    });
  }

};

MapWithMarkersSimple.prototype.addPOIs = function () {

  var self = this;

  // add points of interest to map
  // var pointIndex = 0;

  // for each marker
  this.geoJson.features.forEach(function (marker) {

    let popupClassString = `${self.options.baseClass}__popup`;
    if (marker.properties.mainProperty) {
      popupClassString += ` ${self.options.baseClass}__popup--mainProperty`;
    }

    // create the popup
    let popup;
    if (marker.properties.markerLink) {
      popup = new mapboxgl.Popup({
          offset: 0,
          className: popupClassString,
          anchor: 'bottom'
        })
        .setHTML(`
				<a href="${marker.properties.markerLink}" class="${self.options.baseClass}__popup__content">
					<div class="${self.options.baseClass}__popup__content__heading">${marker.properties.markerTitle}</div>
					<div class="${self.options.baseClass}__popup__content__subheading">${marker.properties.markerSubtitle}</div>
				</a>
			`);
    } else {
      popup = new mapboxgl.Popup({
          offset: 0,
          className: popupClassString,
          anchor: 'bottom'
        })
        .setHTML(`
				<div class="${self.options.baseClass}__popup__content">
					<div class="${self.options.baseClass}__popup__content__heading">${marker.properties.markerTitle}</div>
					<div class="${self.options.baseClass}__popup__content__subheading">${marker.properties.markerSubtitle}</div>
				</div>
			`);
    }


    // create DOM element for the marker
    let el = $(`
			<div id="${marker.properties.markerId}" class="${self.options.baseClass}__marker">
				${marker.properties.iconInlineCode}
			</div>
		`)[0];

    if (marker.properties.mainProperty) {
      el.className += ` ${self.options.baseClass}__marker--mainProperty`;
    }

    // create the marker
    new mapboxgl.Marker(el)
      .setLngLat(marker.geometry.coordinates)
      .setPopup(popup) // sets a popup on this marker
      .addTo(self.map);

    console.log('add marker to map');
    console.log(marker);








    /*

    // create a DOM element for the marker
    var el = document.createElement('div');
    el.id = marker.properties.markerId;
    el.className = `${self.options.baseClass}__marker`;

    if (marker.properties.mainProperty) {
    	el.className += ` ${self.options.baseClass}__marker--mainProperty`;
    }
    // console.log(marker.properties.mainProperty);

    // add our data information
    el.dataset.markerLng = marker.geometry.coordinates[0];
    el.dataset.markerLat = marker.geometry.coordinates[1];

    var $markerArrow = $(`<div class="${self.options.baseClass}__marker__arrow"></div>`);

    var $markerOuterWrapper = $(`<div class="${self.options.baseClass}__markerOuterWrapper"></div>`);
    $markerOuterWrapper.append($markerArrow);

    // our marker content wrapper
    var $markerContentWrapper = $(`<div class="${self.options.baseClass}__markerContentWrapper"></div>`)

    // set up our text detail div that will be added to the marker after the image
    if (marker.properties.markerLink != '')
    {
    	var $markerDetailWrapper = $('<a href="' + marker.properties.markerLink + `" class="${self.options.baseClass}__markerDetailWrapper"></a>`);
    	var $markerDetailPlaceholderWrapper = $(`<div class="${self.options.baseClass}__markerDetailWrapperPlaceholder ${self.options.baseClass}__linkPlaceholder"></div>`);
    }
    else
    {
    	var $markerDetailWrapper = $(`<div class="${self.options.baseClass}__markerDetailWrapper"></div>`);
    	var $markerDetailPlaceholderWrapper = $(`<div class="${self.options.baseClass}__markerDetailWrapperPlaceholder"></div>`);
    }

    var $markerDetail = $(`<div class="${self.options.baseClass}__markerDetail"></div>`);
    var $markerTitle = $(`<div class="${self.options.baseClass}__markerTitle">` + marker.properties.markerTitle + '</div>');
    var $markerSubtitle = $(`<div class="${self.options.baseClass}__markerAddress">` + marker.properties.markerSubtitle + '</div>');

    // set up our placeholder marker detail that will be added after the image
    // this is used by the css to allow the marker height to remain the same when the detail content is position: absolute
    $markerDetail.append($markerTitle);

    if (marker.properties.markerSubtitle != '')
    {
    	$markerDetail.append($markerSubtitle);
    }

    $markerDetailWrapper.append($markerDetail);
    $markerDetailPlaceholderWrapper.append($markerDetail.clone());

    // this is a modified version of our SVG replacement script
    // it goes through the markers, and inlines any SVG icons
    if (marker.properties.icon.match(/.*\.svg/))
    {

    	$.ajax({
    		url: marker.properties.icon,
    		dataType: 'xml',
    		success: function(data) {

    			var $wrapperDiv = $('<div class="inline-svg-wrapper"></div>');

    			// Get the SVG tag, ignore the rest
    			var $svg = $(data).find('svg');

    			// IE doesn't scale SVG properly so we need to use a canvas object
    			if($svg.attr('height') && $svg.attr('width')) {
    				var $canvas = $('<canvas class="svg-frame" height="' + $svg.attr('height') + '" width="' + $svg.attr('width') + '"></canvas>');
    			}
    			else {
    				var $canvas = $('<canvas class="svg-frame" height="1" width="1"></canvas>');
    			}

    			$wrapperDiv.append($canvas);

    			// Add replaced image's ID to the new SVG
    			if(typeof imgID !== 'undefined') {
    				$svg = $svg.attr('id', imgID);
    			}

    			// Add replaced image's classes to the new SVG
    			if(typeof imgClass !== 'undefined') {
    				$svg = $svg.attr('class', imgClass + ' replaced-svg');
    			}

    			// Remove any invalid XML tags as per http://validator.w3.org
    			$svg = $svg.removeAttr('xmlns:a');

    			// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
    			if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
    				$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
    			}

    			// do not include height and width attributes on svg
    			$svg.removeAttr('height');
    			$svg.removeAttr('width');

    			$wrapperDiv.append($svg);

    			// icon wrapper div
    			var $iconWrapperDiv = $(`<div class="${self.options.baseClass}__iconWrapper"></div>`);
    			$iconWrapperDiv.append($wrapperDiv);

    			// insert $wrapperDiv into our marker wrapper element
    			$markerContentWrapper.append($iconWrapperDiv);

    			// add our text div
    			$markerContentWrapper.append($markerDetailWrapper);
    			$markerContentWrapper.append($markerDetailPlaceholderWrapper);

    			$markerOuterWrapper.append($markerContentWrapper);
    		}
    	});

    }
    else
    {
    	// if not an SVG, just use regular image element
    	var imgEl = document.createElement('img');
    	imgEl.src = marker.properties.icon;

    	// icon wrapper div
    	var $iconWrapperDiv = $(`<div class="${self.options.baseClass}__iconWrapper"></div>`);
    	$iconWrapperDiv.append($(imgEl));

    	// insert $wrapperDiv into our marker wrapper element
    	$markerContentWrapper.append($iconWrapperDiv);

    	// add our text div
    	$markerContentWrapper.append($markerDetailWrapper);
    	$markerContentWrapper.append($markerDetailPlaceholderWrapper);

    	$markerOuterWrapper.append($markerContentWrapper);
    }

    el.appendChild($markerOuterWrapper[0]);

    // get this marker's height so that we can set the offset accordingly
    $(el).find(`.${self.options.baseClass}__markerDetailWrapperPlaceholder`).height();

    // add marker to map
    var mapboxMarker = new mapboxgl.Marker({
    		element: el,
    		offset: [119, -48], // offset by half of width, and by half of height + 16px (for arrow)
    	})
    	.setLngLat(marker.geometry.coordinates)
    	.addTo(self.map);

    pointIndex++;

    self.mapboxMarkers.push(mapboxMarker);

    */

  });

  // this block sets the offset of the markers based on their width and height
  // we run this until the height and width of all markers is registered
  // have to use an interval because the DOM doesn't update immediately
  /*
  this.setMarkerOffsetsInterval =  window.setInterval(function() {

  	var allMarkersInsertedIntoDom = true;

  	// go through the mapbox markers we added to our array
  	$.each(self.mapboxMarkers, function() {

  		var markerInnerHeight = $(this._element).height();
  		var markerInnerWidth = $(this._element).width();

  		var markerHeight = $(this._element).outerHeight();
  		var markerWidth = $(this._element).outerWidth();

  		var markerOffsetX = markerWidth / 2;
  		var markerOffsetY = ((markerHeight / 2) + 16) * -1; // adding 16 to account for the :before triangle pointing down
  		
  		if (markerInnerHeight == 0 || markerInnerWidth == 0)
  		{
  			allMarkersInsertedIntoDom = false;
  		}
  		else
  		{
  			// set the marker offset here
  			this.setOffset([markerOffsetX, markerOffsetY]);
  		}

  	});

  	// once all markers have been inserted and offsets set, clear the interval to stop running loop
  	if (allMarkersInsertedIntoDom) {
  		window.clearInterval(self.setMarkerOffsetsInterval);

  		self.animateIn();

  	}

  }, 100);
  */

};

/*
MapWithMarkersSimple.prototype.animateIn = function() {

	var self = this;

	// animate in
	gsap.timeline(
		{
			scrollTrigger: {
				trigger: self.options.$el,
				start: '90% bottom',
				end: '50% top',
				// markers: true,
			},
			delay: 0,
		}
	)
	.add(
		function() {
			self.centerMapAroundMarkers();
		}
	)
	.set(self.options.$el.find(`.${self.options.baseClass}__marker`),
		{
			opacity: 1
		}
	)
	.from(self.options.$el.find(`.${self.options.baseClass}__markerOuterWrapper`),
		{
			duration: 0.15,
			ease: "power1.out",
			opacity: 0,
			stagger: {
				each: 0.1
			}
			//ease: "power1.out",
		},
		"0.7"
	)
	.from(self.options.$el.find(`.${self.options.baseClass}__markerOuterWrapper`),
		{
			duration: 0.35,
			ease: "power1.out",
			yPercent: -50,
			stagger: {
				each: 0.1
			}
			//ease: "power1.out",
		},
		"<"
	)
	;

};
*/

export default MapWithMarkersSimple;